<template>
    <el-button type="danger" size="mini" plain @click="onSubmit()" title="Delete">
        Delete
    </el-button>
</template>

<script>
export default {
    props: {
        id: {
            required: true,
            type: String,
        },
    },

    methods: {
        async onSubmit() {
            try {
                await this.$confirm('The ingredient will be removed from this recipe.', 'Confirm Delete', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
            } catch(err) {
                return false
            }

            try {
                var { data } = await this.$http.delete(`/recipe-ingredients/${ this.id }`)
            } catch(err) {
                this.$message.error(err.response.data.message)

                return false
            }

            this.$emit('delete')
            this.$message.success(data.message)
        },
    },
}
</script>
